//#region importSection
import React, { useEffect } from "react";
import Draggable from "react-draggable";
import {
  Button,
  Form,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { GetLanguageString } from "../helper/Components";
import { useState } from "react";
import {
  customMultiValue,
  customOption,
  LoadingSpinner,
} from "../../constants/const";
import Select from "react-select";
import ApiSyllabusBook from "../config/setupsyllabus/ApiSetupBook";
import { SweetAlertComponent } from "../config/SweetAlertComponent";
import { GetSelectedLanguage } from "../helper/Method";
//#endregion importSection

const UpdateMemberNisabBooks = ({ memberId, onClose, currentItem }) => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [loading, setLoading] = useState(false);
  const [syllabuses, setsyllabuses] = useState([]);
  //const [selectedIds, setSelectedIds] = useState([]);
  const [allbooks, setallBooks] = useState([]);
  const [memberReadBooks, setMemberReadBooks] = useState([]);
  const [selectedSyllabusId, setSelectedSyllabusId] = useState(null);
  //#endregion declareStates
  //#region useStates
  useEffect(() => {
    setLoading(true);

    ApiSyllabusBook()
      .GetSyllabusesSelectList()
      .then((res) => {
        setsyllabuses(res.data);

        setLoading(false);
      });
  }, [currentItem, memberId]);
  //#endregion useStates
  //#region FunctionsSections
  const handleChangeSyllabus = (syllabusId) => {
    setSelectedSyllabusId(syllabusId);
    ApiSyllabusBook()
      .GetSyllabusBooksWithMemberSelection({
        CourseName: syllabusId,
        MemberId: memberId,
      })
      .then((res) => {
        setallBooks(res.data.allBooks);
        setMemberReadBooks(res.data.memberBooks);
      });
    // fetch books here
  };
  const handleBooksChange = (selectedOptions) => {
    setMemberReadBooks(selectedOptions || []); // store selected books
    console.log("Selected books:", selectedOptions);

    // If you need just the IDs for backend
    const selectedIds = (selectedOptions || []).map((opt) => opt.value);
    console.log("Selected IDs:", selectedIds);

    // Optionally: send to backend immediately
    // saveMemberBooks(memberId, selectedIds);
  };
  const handleDrag = (e, ui) => {
    const { x, y } = position;
    setPosition({ x: x + ui.deltaX, y: y + ui.deltaY });
  };
  const handleSubmit = (e) => {
    setLoading(true);
    e.preventDefault();
    const selectedIds = (memberReadBooks || []).map((opt) => opt.value);

    console.log("Submitting...");
    console.log("Syllabus ID:", selectedSyllabusId);
    console.log("Book IDs:", selectedIds);
    ApiSyllabusBook()
      .UpdateMemberNisaabBooks({
        SetupSyllabusBookIds: selectedIds,
        MemberId: memberId,
        CourseName: selectedSyllabusId,
      })

      .then((res) => {
        if (res.data.statusCode === "200") {
          setLoading(false);
          onClose(false);
          SweetAlertComponent({
            messageKey: "dawati_nisab_updated",
            statusCode: res.data.statusCode,
          });
        }
      })
      .catch((err) => {
        setLoading(false);
      });
  };
  //endregion FunctionsSections
  return (
    <Draggable position={position} onDrag={handleDrag} cancel=".no-drag">
      <Modal isOpen={true} className="inmodal" autoFocus={false}>
        <ModalHeader className="modal-title" tag="h4">
          <GetLanguageString props="update_dawati_nisab" />
        </ModalHeader>
        {!loading ? (
          <Form onSubmit={handleSubmit}>
            <ModalBody>
              <FormGroup>
                <Label className="col-form-label">
                  {<GetLanguageString props="select_nisaab" />}
                </Label>
                <Select
                  onChange={(selectedOption) =>
                    handleChangeSyllabus(selectedOption?.label)
                  }
                  components={{
                    Option: customOption,
                  }}
                  options={syllabuses}
                  className={"basic-select ur no-drag"}
                  placeholder={
                    GetSelectedLanguage() === "en" ? "Select" : "منتخب کریں"
                  }
                />
              </FormGroup>
              <FormGroup>
                <Label className="col-form-label">
                  {<GetLanguageString props="select_book" />}
                </Label>
                <Select
                  value={memberReadBooks}
                  components={{
                    Option: customOption,
                    MultiValue: customMultiValue,
                  }}
                  options={allbooks}
                  className={
                    GetSelectedLanguage() === "ur"
                      ? "basic-multi-select ur no-drag"
                      : "basic-multi-select no-drag"
                  }
                  classNamePrefix="select"
                  placeholder={
                    GetSelectedLanguage() === "en"
                      ? "Select Book"
                      : "منتخب کریں"
                  }
                  isMulti
                  onChange={handleBooksChange}
                />
              </FormGroup>
            </ModalBody>
            <ModalFooter>
              <Button color="white" onClick={() => onClose(false)}>
                <GetLanguageString props="common_cancel" />
              </Button>
              <Button color="primary" type="submit">
                <GetLanguageString props="update" />
              </Button>{" "}
            </ModalFooter>
          </Form>
        ) : (
          LoadingSpinner()
        )}
      </Modal>
    </Draggable>
  );
};

export default UpdateMemberNisabBooks;
